import { createAction } from '@reduxjs/toolkit'

// app ui
export const actionErrMsg = createAction<string>('UI_ERROR_MESSAGE')
export const actionLoading = createAction<boolean>('UI_SHOW_LOADING')

export const actionTokenId = createAction<string>('TOKEN_ID')
export const actionTokenOwner = createAction<string>('TOKEN_OWNER')
export const actionTokenURI = createAction<string>('TOKEN_URI')